export const config = {
    env: 'prod',
    dev: {
        url: 'https://dev-daijiaapi.threeape.com',
        webUrl: 'http://mp.bzffs.cc/#/address?service_id=1',
        baiduKey: 'OQBBZ-HLAKQ-2M35E-477VD-7EXBF-KPFZD',
        cryptoKey: 'daijia_hsf'
    },
    prod: {
        url: 'https://hsf-api.threeape.com',
        webUrl: 'https://mp.threeape.com/#/address?service_id=2',
        baiduKey: 'OQBBZ-HLAKQ-2M35E-477VD-7EXBF-KPFZD',
        cryptoKey: 'daijia_hsf'
    }
}



// WEBPACK FOOTER //
// ./src/utils/config.js